<template>
  <div>
    <modal v-model:show="errors.length" modal-classes="modal-danger" modal-content-classes="bg-gradient-danger">
      <template v-slot:header>
        <h6 class="modal-title">{{ $t($route.name + '.errorsModalTitle') }}</h6>
      </template>

      <div class="py-3 text-center">
        <i class="ni ni-support-16 ni-3x"></i>
        <h4 class="heading mt-4">{{ $t($route.name + '.errorsModalBodyTitle') }}</h4>
        <ul v-for="error in errors" :key="error">
          <li>{{ error }}</li>
        </ul>
      </div>

      <template v-slot:footer>
        <base-button type="link" class="text-white ml-auto" v-on:click="errors = []">{{ $t($route.name +
          '.errorsModalCloseButton') }}</base-button>
      </template>
    </modal>
    <div class="card">
      <div class="card-header border-0">
        <div class="row align-items-center">
          <div class="col">
            <h3 class="mb-0" v-if="plot_front_data.plot_selected != 'new_plot_selected'">{{
              $t(this.$route.name + '.plotsManagerTitle') }} {{ plot_front_data.plot_selected }}</h3>
            <h3 class="mb-0" v-else>{{ $t(this.$route.name + '.plotsManagerNewPlotTitle') }}</h3>
          </div>
        </div>
      </div>

      <div class="card-body" id="card-body-custom">
        <div class="row" id="row-plot-body">
          <div class="col">
            <div id="plot-details">
              <div class="nav-wrapper">
                <ul class="nav nav-pills nav-fill flex-column flex-md-row" id="tabs-icons-text" role="tablist">
                  <li class="nav-item">
                    <div v-if="plot_front_data.selected_nav == 'profile'">
                      <a class="nav-link mb-sm-3 mb-md-0 active" id="tabs-icons-text-1-tab" data-toggle="tab" role="tab"
                        aria-controls="tabs-icons-text-1" aria-selected="true"
                        v-on:click="onPlotNavButtonsClick('profile')">{{ $t(this.$route.name + '.profileNavButton') }}</a>
                    </div>
                    <div v-else>
                      <a class="nav-link mb-sm-3 mb-md-0" id="tabs-icons-text-1-tab" data-toggle="tab" role="tab"
                        aria-controls="tabs-icons-text-1" aria-selected="true"
                        v-on:click="onPlotNavButtonsClick('profile')">{{ $t(this.$route.name + '.profileNavButton') }}</a>
                    </div>
                  </li>
                  <li class="nav-item">
                    <div v-if="plot_front_data.selected_nav == 'params'">
                      <a class="nav-link mb-sm-3 mb-md-0 active" id="tabs-icons-text-2-tab" data-toggle="tab" role="tab"
                        aria-controls="tabs-icons-text-2" aria-selected="false"
                        v-on:click="onPlotNavButtonsClick('params')">{{ $t(this.$route.name + '.paramsNavButton') }}</a>
                    </div>
                    <div v-else>
                      <a class="nav-link mb-sm-3 mb-md-0" id="tabs-icons-text-2-tab" data-toggle="tab" role="tab"
                        aria-controls="tabs-icons-text-2" aria-selected="false"
                        v-on:click="onPlotNavButtonsClick('params')">{{ $t(this.$route.name + '.paramsNavButton') }}</a>
                    </div>
                  </li>
                  <li class="nav-item">
                    <div v-if="plot_front_data.selected_nav == 'modules'">
                      <a class="nav-link mb-sm-3 mb-md-0 active" id="tabs-icons-text-3-tab" data-toggle="tab" role="tab"
                        aria-controls="tabs-icons-text-3" aria-selected="false"
                        v-on:click="onPlotNavButtonsClick('modules')">{{ $t(this.$route.name + '.modulesNavButton') }}</a>
                    </div>
                    <div v-else>
                      <a class="nav-link mb-sm-3 mb-md-0" id="tabs-icons-text-3-tab" data-toggle="tab" role="tab"
                        aria-controls="tabs-icons-text-3" aria-selected="false"
                        v-on:click="onPlotNavButtonsClick('modules')">{{ $t(this.$route.name + '.modulesNavButton') }}</a>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="card shadow">
                <div class="card-body">
                  <form role="form" v-on:submit.prevent="handleUpdatePlot">
                    <div v-if="plot_front_data.selected_nav == 'profile'">
                      <!-- Plot profile -->
                      <!-- Plot name -->
                      <div class="row">
                        <div class="col">


                          <span>{{ $t($route.name + '.plotName') }}</span>
                          <Popper arrow :content="$t($route.name + '.plotNameInfoPopover')" class="light">
                            <a type="button"><i class="ni ni-bulb-61"></i></a>
                          </Popper>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          <div class="form-group" :class="{ error: v$.plot_model.name.$errors.length }">
                            <base-input formClasses="input-group-alternative" type="text"
                              v-model="v$.plot_model.name.$model"
                              :error="errorsArrayToSingleString(v$.plot_model.name.$errors)"
                              :placeholder="$t($route.name + '.plotNamePlaceholder')">
                            </base-input>
                          </div>
                        </div>
                      </div>

                      <!-- Plot area and crop area -->
                      <div class="row">
                        <div class="col">
                          <div class="row">
                            <div class="col">
                              <span>{{ $t($route.name + '.plotArea') }}</span>
                              <Popper arrow class="light" :content="$t($route.name + '.plotAreaInfoPopover')">
                                <a type="button"><i class="ni ni-bulb-61"></i></a>
                              </Popper>
                            </div>
                            <div class="col">
                              <div class="form-group">
                                <base-input formClasses="input-group-alternative" type="number" placeholder="0.000"
                                  step="0.001" min="0.000" v-model="v$.plot_model.params.plot_area.$model"
                                  :error="errorsArrayToSingleString(v$.plot_model.params.plot_area.$errors)">
                                </base-input>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col">
                          <div class="row">
                            <div class="col">
                              <span>{{ $t($route.name + '.plotCropArea') }}</span>
                              <Popper arrow class="light" :content="$t($route.name + '.plotCropAreaInfoPopover')">
                                <a type="button"><i class="ni ni-bulb-61"></i></a>
                              </Popper>
                            </div>
                            <div class="col">
                              <div class="form-group">
                                <base-input formClasses="input-group-alternative" type="number" placeholder="0.000"
                                  step="0.001" min="0.000" v-model="v$.plot_model.params.total_crop_area.$model"
                                  :error="errorsArrayToSingleString(v$.plot_model.params.total_crop_area.$errors)">
                                </base-input>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- End of plot area and crop area -->

                      <!-- Associated terrain -->
                      <div class="row">
                        <div class="col">
                          <span>{{ $t($route.name + '.plotAssociatedTerrain') }}</span>
                          <Popper arrow class="light" :content="$t($route.name + '.plotAssociatedTerrainInfoPopover')">
                            <a type="button"><i class="ni ni-bulb-61"></i></a>
                          </Popper>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          <select v-model="plot_model.terrain_id" @change="onTerrainChange($event)">
                            <option active disabled value="">{{ $t(this.$route.name + '.askForTerrainSelectorDisabled') }}
                            </option>
                            <option v-for="_terrain of landlord.terrains" :key=_terrain v-bind:value="_terrain.id">
                              {{ _terrain.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <!-- End of associated terrain -->
                      <br>
                      <!-- sigpac code -->
                      <div class="row">
                        <div class="col">
                          <span>{{ $t($route.name + '.plotSigpacCode') }}</span>
                          <Popper arrow class="light" :content="$t($route.name + '.plotSigpacCodeInfoPopover')">
                                <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          <base-input formClasses="input-group-alternative" type="text"
                            v-model="plot_model.params.sigpac_code" disabled>
                          </base-input>
                        </div>
                      </div>
                      <!-- End of sigpac code -->
                    </div>

                    <!-- Plot params details -->
                    <div v-else-if="plot_front_data.selected_nav == 'params'">
                      <!-- Crop card -->
                      <div class="row">
                        <div class="col">
                          <div class="card shadow">
                            <div class="card-header border-0">
                              <div class="row align-items-center" v-on:click="onCollapseButtonToggle('crop')">
                                <div class="col">
                                  <h4 class="mb-0">{{ $t(this.$route.name + '.paramsCropTitle') }}</h4>
                                </div>
                                <div class="col-md-auto">
                                  <div v-if="plot_front_data.colapsed_params.crop">
                                    <i class="ni ni-fat-add"></i>
                                  </div>
                                  <div v-else>
                                    <i class="ni ni-fat-delete"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- Card Body -->
                            <div v-if="!plot_front_data.colapsed_params.crop">
                              <div class="card-body">
                                <!-- crop_type -->
                                <div class="row">
                                  <div class="col">
                                    <span>{{ $t($route.name + '.paramsCropType') }}</span>
                                    
                                    <Popper arrow class="light" :content="$t($route.name + '.paramsCropTypeInfoPopover')">
                                          <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
                                  </div>
                                  <div class="col">
                                    <div class="form-group">
                                      <select v-model="plot_model.params.crop.crop_type">
                                        <option v-for="crop in getCropType()" :key="crop" :value="crop">
                                          {{ $t(this.$route.name + '.crop_list.' + crop) }}
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                <!-- End of crop_type -->

                                <!-- Crop plantation_age -->
                                <div class="row">
                                  <div class="col">
                                    <span>{{ $t($route.name + '.paramsCropPlantationAge') }}</span>
                                    <Popper arrow class="light" :content="$t($route.name + '.paramsCropPlantationAgeInfoPopover')">
                                          <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
                                  </div>
                                  <div class="col">
                                    <div class="form-group">
                                      <base-input formClasses="input-group-alternative" type="text"
                                        :placeholder="$t($route.name + '.paramsCropPlantationAgePlaceholder')"
                                        v-model="v$.plot_model.params.crop.plantation_age.$model"
                                        :error="errorsArrayToSingleString(v$.plot_model.params.crop.plantation_age.$errors)">
                                      </base-input>
                                    </div>
                                  </div>
                                </div>
                                <!-- End of Crop plantation_age -->

                                <!-- Crop variety -->
                                <div class="row">
                                  <div class="col">
                                    <span>{{ $t($route.name + '.paramsCropVariety') }}</span>
                                    <Popper arrow class="light" :content="$t($route.name + '.paramsCropVarietyInfoPopover')">
                                          <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
                                  </div>
                                  <div class="col">
                                    <div class="form-group">
                                      <base-input formClasses="input-group-alternative" type="text"
                                        :placeholder="$t($route.name + '.paramsCropVarietyPlaceholder')"
                                        v-model="v$.plot_model.params.crop.variety.$model"
                                        :error="errorsArrayToSingleString(v$.plot_model.params.crop.variety.$errors)">
                                      </base-input>
                                    </div>
                                  </div>
                                </div>
                                <!-- End of Crop variety -->

                                <!-- Crop variety_type -->
                                <div class="row">
                                  <div class="col">
                                    <span>{{ $t($route.name + '.paramsCropVarietyType') }}</span>
                                    <Popper arrow class="light" :content="$t($route.name + '.paramsCropVarietyTypeInfoPopover')">
                                          <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
                                  </div>
                                  <div class="col">
                                    <div class="form-group">
                                      <select v-model="plot_model.params.crop.variety_type">
                                        <option v-for="cropVariety in getCropTypeVarieties()" :key="cropVariety"
                                          :value="cropVariety">
                                          {{ $t(this.$route.name + '.cropVariety_' + cropVariety) }}
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                <!-- End of Crop variety_type -->

                                <!-- Crop tree_distance -->
                                <div class="row">
                                  <div class="col">
                                    <span>{{ $t($route.name + '.paramsCropTreeDistance') }}</span>
                                    <Popper arrow class="light" :content="$t($route.name + '.paramsCropTreeDistanceInfoPopover')">
                                          <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
                                  </div>
                                  <div class="col">
                                    <div class="form-group">
                                      <base-input formClasses="input-group-alternative" type="number" placeholder="0.000"
                                        step="0.001" min="0.000" v-model="v$.plot_model.params.crop.tree_distance.$model"
                                        :error="errorsArrayToSingleString(v$.plot_model.params.crop.tree_distance.$errors)">
                                      </base-input>
                                    </div>
                                  </div>
                                </div>
                                <!-- End of Crop tree_distance -->

                                <!-- Crop row_distance -->
                                <div class="row">
                                  <div class="col">
                                    <span>{{ $t($route.name + '.paramsCropRowDistance') }}</span>
                                    <Popper arrow class="light" :content="$t($route.name + '.paramsCropRowDistanceInfoPopover')">
                                          <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
                                  </div>
                                  <div class="col">
                                    <div class="form-group">
                                      <base-input formClasses="input-group-alternative" type="number" placeholder="0.000"
                                        step="0.001" min="0.000" v-model="v$.plot_model.params.crop.row_distance.$model"
                                        :error="errorsArrayToSingleString(v$.plot_model.params.crop.row_distance.$errors)">
                                      </base-input>
                                    </div>
                                  </div>
                                </div>
                                <!-- End of Crop row_distance -->

                                <!-- Crop crown_diameter -->
                                <div class="row">
                                  <div class="col">
                                    <span>{{ $t($route.name + '.paramsCropCrownDiameter') }}</span>
                                    <Popper arrow class="light" :content="$t($route.name + '.paramsCropCrownDiameterInfoPopover')">
                                          <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
                                  </div>
                                  <div class="col">
                                    <div class="form-group">
                                      <base-input formClasses="input-group-alternative" type="number" placeholder="0.000"
                                        step="0.001" min="0.000" v-model="v$.plot_model.params.crop.crown_diameter.$model"
                                        :error="errorsArrayToSingleString(v$.plot_model.params.crop.crown_diameter.$errors)">
                                      </base-input>
                                    </div>
                                  </div>
                                </div>
                                <!-- End of Crop crown_diameter -->

                                <!-- Crop cup_height -->
                                <div class="row">
                                  <div class="col">
                                    <span>{{ $t($route.name + '.paramsCropCupHeight') }}</span>
                                    <Popper arrow class="light" :content="$t($route.name + '.paramsCropCupHeightInfoPopover')">
                                          <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
                                  </div>
                                  <div class="col">
                                    <div class="form-group">
                                      <base-input formClasses="input-group-alternative" type="number" placeholder="0.000"
                                        step="0.001" min="0.000" v-model="v$.plot_model.params.crop.cup_height.$model"
                                        :error="errorsArrayToSingleString(v$.plot_model.params.crop.cup_height.$errors)">
                                      </base-input>
                                    </div>
                                  </div>
                                </div>
                                <!-- End of Crop cup_height -->

                                <!-- Crop visible_root_depth -->
                                <div class="row">
                                  <div class="col">
                                    <span>{{ $t($route.name + '.paramsCropVisibleRootDepth') }}</span>
                                    <Popper arrow class="light" :content="$t($route.name + '.paramsCropVisibleRootDepthInfoPopover')">
                                          <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
                                  </div>
                                  <div class="col">
                                    <div class="form-group">
                                      <base-input formClasses="input-group-alternative" type="number" placeholder="0.000"
                                        step="0.001" min="0.000"
                                        v-model="v$.plot_model.params.crop.visible_root_depth.$model"
                                        :error="errorsArrayToSingleString(v$.plot_model.params.crop.visible_root_depth.$errors)">
                                      </base-input>
                                    </div>
                                  </div>
                                </div>
                                <!-- End of Crop visible_root_depth -->

                                <!-- Crop covered_presence -->
                                <div class="row">
                                  <div class="col">
                                    <span>{{ $t($route.name + '.paramsCropCoveredPresence') }}</span>
                                    <Popper arrow class="light" :content="$t($route.name + '.paramsCropCoveredPresenceInfoPopover')">
                                          <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
                                  </div>
                                  <div class="col">
                                    <div class="form-group">
                                      <base-switch :value="plot_model.params.crop.covered_presence"
                                        @input="plot_model.params.crop.covered_presence = Boolean($event)">
                                      </base-switch>
                                    </div>
                                  </div>
                                </div>
                                <!-- End of Crop covered_presence -->

                                <!-- crop_coefficient -->
                                <!--<div class="row">
                                    <div class="col">
                                      <span>{{$t($route.name+'.paramsCropCoefficient')}}</span>
                                      <Popper arrow class="light" :content="$t($route.name+'.paramsCropCoefficientInfoPopover')"
                                        >
                                            <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
                                    </div>
                                    <div class="col">
                                      <div class="form-group">
                                        <base-input
                                            formClasses="input-group-alternative"
                                            type="number"
                                            placeholder="0.000"
                                            step="0.001"
                                            min="0.000"
                                            v-model="v$.plot_model.params.crop.crop_coefficient.$model"
                                            :error="errorsArrayToSingleString(v$.plot_model.params.crop.crop_coefficient.$errors)"
                                        >
                                        </base-input>
                                      </div>  
                                    </div>
                                  </div>
                                  -->
                                <!-- End of crop_coefficient -->

                                <!-- crop_development_coefficient -->
                                <div class="row">
                                  <div class="col">
                                    <span>{{ $t($route.name + '.paramsCropDevelopmentCoefficient') }}</span>
                                    <Popper arrow class="light" :content="$t($route.name + '.paramsCropDevelopmentCoefficientInfoPopover')">
                                          <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
                                  </div>
                                  <div class="col">
                                    <div class="form-group">
                                      <base-input formClasses="input-group-alternative" disabled type="number"
                                        placeholder="1.000" min="0.000" max="1.000"
                                        v-model="v$.plot_model.params.crop.crop_development_coefficient.$model"
                                        :value="get_crop_development_coefficient()">
                                      </base-input>
                                    </div>
                                  </div>
                                </div>
                                <!-- End of crop_development_coefficient -->
                              </div>
                            </div>
                            <!-- End of Card-Body -->
                          </div>
                          <!-- End of Crop card -->
                        </div>
                        <!-- End of Row -->
                      </div>

                      <!-- Irrigation card -->
                      <div class="row">
                        <div class="col">
                          <div class="card shadow">
                            <div class="card-header border-0">
                              <div class="row align-items-center" v-on:click="onCollapseButtonToggle('irrigation')">
                                <div class="col">
                                  <h4 class="mb-0">{{ $t(this.$route.name + '.paramsIrrigationTitle') }}</h4>
                                </div>
                                <div class="col-md-auto">
                                  <div v-if="plot_front_data.colapsed_params.irrigation">
                                    <i class="ni ni-fat-add"></i>
                                  </div>
                                  <div v-else>
                                    <i class="ni ni-fat-delete"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- Card Body -->
                            <div v-if="!plot_front_data.colapsed_params.irrigation">
                              <div class="card-body">
                                <!-- Irrigation irrigation_system -->
                                <div class="row">
                                  <div class="col">
                                    <span>{{ $t($route.name + '.paramsIrrigationSystem') }}</span>
                                    <Popper arrow class="light" :content="$t($route.name + '.paramsIrrigationSystemInfoPopover')">
                                          <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
                                  </div>
                                  <div class="col">
                                    <div class="form-group">
                                      <select v-model="plot_model.params.irrigation.irrigation_system"
                                        @change="onIrrigationSystemSelected()">
                                        <option v-for="system in getIrrigationSystems()" :key="system" :value="system">
                                          {{ $t(this.$route.name + '.' + system) }}
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                <!-- End of Irrigation irrigation_system -->

                                <!-- Irrigation dropper_type -->
                                <div class="row">
                                  <div class="col">
                                    <span>{{ $t($route.name + '.paramsDropperType') }}</span>
                                    <Popper arrow class="light" :content="$t($route.name + '.paramsDropperTypeInfoPopover')">
                                          <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
                                  </div>
                                  <div class="col">
                                    <div class="form-group">
                                      <select v-model="plot_model.params.irrigation.dropper_type">
                                        <option v-for="dropper in getDropperTypes()" :key="dropper" :value="dropper">
                                          {{ $t(this.$route.name + '.' + dropper) }}
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                <!-- End of Irrigation dropper_type -->

                                <!-- Irrigation dropper_flow -->
                                <div class="row">
                                  <div class="col">
                                    <span>{{ $t($route.name + '.paramsDropperFlow') }}</span>
                                    <Popper arrow class="light" :content="$t($route.name + '.paramsDropperFlowInfoPopover')">
                                          <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
                                  </div>
                                  <div class="col">
                                    <div class="form-group">
                                      <base-input formClasses="input-group-alternative" type="number" placeholder="0.000"
                                        step="0.001" min="0.000"
                                        v-model="v$.plot_model.params.irrigation.dropper_flow.$model"
                                        :error="errorsArrayToSingleString(v$.plot_model.params.irrigation.dropper_flow.$errors)">
                                      </base-input>
                                    </div>
                                  </div>
                                </div>
                                <!-- End of Irrigation dropper_flow -->

                                <!-- Irrigation droppers_per_tree -->
                                <div class="row">
                                  <div class="col">
                                    <span>{{ $t($route.name + '.paramsDroppersPerTree') }}</span>
                                    <Popper arrow class="light" :content="$t($route.name + '.paramsDroppersPerTreeInfoPopover')">
                                          <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
                                  </div>
                                  <div class="col">
                                    <div class="form-group">
                                      <base-input formClasses="input-group-alternative" type="number" placeholder="0.000"
                                        step="0.001" min="0.000"
                                        v-model="v$.plot_model.params.irrigation.droppers_per_tree.$model"
                                        :error="errorsArrayToSingleString(v$.plot_model.params.irrigation.droppers_per_tree.$errors)">
                                      </base-input>
                                    </div>
                                  </div>
                                </div>
                                <!-- End of Irrigation droppers_per_tree -->

                                <!-- Irrigation droppers_distance -->
                                <div class="row">
                                  <div class="col">
                                    <span>{{ $t($route.name + '.paramsDroppersDistance') }}</span>
                                    <Popper arrow class="light" :content="$t($route.name + '.paramsDroppersDistanceInfoPopover')">
                                          <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
                                  </div>
                                  <div class="col">
                                    <div class="form-group">
                                      <base-input formClasses="input-group-alternative" type="number" placeholder="0.000"
                                        step="0.001" min="0.000"
                                        v-model="v$.plot_model.params.irrigation.droppers_distance.$model"
                                        :error="errorsArrayToSingleString(v$.plot_model.params.irrigation.droppers_distance.$errors)">
                                      </base-input>
                                    </div>
                                  </div>
                                </div>
                                <!-- End of Irrigation droppers_distance -->

                                <!-- Irrigation application_efficiency -->
                                <div class="row">
                                  <div class="col">
                                    <span>{{ $t($route.name + '.paramsApplicationEfficiency') }}</span>
                                    <Popper arrow class="light" :content="$t($route.name + '.paramsApplicationEfficiencyInfoPopover')">
                                          <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
                                  </div>
                                  <div class="col">
                                    <div class="form-group">
                                      <base-input formClasses="input-group-alternative" type="number" disabled
                                        placeholder="0.000" step="0.001" min="0.000"
                                        v-model="v$.plot_model.params.irrigation.application_efficiency.$model"
                                        :error="errorsArrayToSingleString(v$.plot_model.params.irrigation.application_efficiency.$errors)">
                                      </base-input>
                                    </div>
                                  </div>
                                </div>
                                <!-- End of Irrigation application_efficiency -->

                              </div>
                              <!-- End of Card-Body -->
                            </div>
                          </div>
                          <!-- End of Irrigation card -->
                        </div>
                        <!-- End of Row -->
                      </div>

                      <!-- Soil card -->
                      <div class="row">
                        <div class="col">
                          <div class="card shadow">
                            <div class="card-header border-0">
                              <div class="row align-items-center" v-on:click="onCollapseButtonToggle('soil')">
                                <div class="col">
                                  <h4 class="mb-0">{{ $t(this.$route.name + '.paramsSoilTitle') }}</h4>
                                </div>
                                <div class="col-md-auto">
                                  <div v-if="plot_front_data.colapsed_params.soil">
                                    <i class="ni ni-fat-add"></i>
                                  </div>
                                  <div v-else>
                                    <i class="ni ni-fat-delete"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- Card Body -->
                            <div v-if="!plot_front_data.colapsed_params.soil">
                              <div class="card-body">
                                <!-- Soil uniformity_coefficient -->
                                <div class="row">
                                  <div class="col">
                                    <span>{{ $t($route.name + '.paramsSoilUniformityCoefficient') }}</span>
                                    <Popper arrow class="light" :content="$t($route.name + '.paramsSoilUniformityCoefficientInfoPopover')">
                                          <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
                                  </div>
                                  <div class="col">
                                    <div class="form-group">
                                      <base-input formClasses="input-group-alternative" type="number" placeholder="0.000"
                                        step="0.001" min="0.000"
                                        v-model="v$.plot_model.params.soil.uniformity_coefficient.$model"
                                        :error="errorsArrayToSingleString(v$.plot_model.params.soil.uniformity_coefficient.$errors)">
                                      </base-input>
                                    </div>
                                  </div>
                                </div>
                                <!-- End of Soil uniformity_coefficient -->

                                <!-- Soil organic_material -->
                                <div class="row">
                                  <div class="col">
                                    <span>{{ $t($route.name + '.paramsSoilOrganicMaterial') }}</span>
                                    <Popper arrow class="light" :content="$t($route.name + '.paramsSoilOrganicMaterialInfoPopover')">
                                          <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
                                  </div>
                                  <div class="col">
                                    <div class="form-group">
                                      <base-input formClasses="input-group-alternative" type="number" placeholder="0.000"
                                        step="0.001" min="0.000"
                                        v-model="v$.plot_model.params.soil.organic_material.$model"
                                        :error="errorsArrayToSingleString(v$.plot_model.params.soil.organic_material.$errors)">
                                      </base-input>
                                    </div>
                                  </div>
                                </div>
                                <!-- End of Soil organic_material -->

                                <!-- Soil clay_percentage -->
                                <div class="row">
                                  <div class="col">
                                    <span>{{ $t($route.name + '.paramsSoilClayPercentage') }}</span>
                                    <Popper arrow class="light" :content="$t($route.name + '.paramsSoilClayPercentageInfoPopover')">
                                          <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
                                  </div>
                                  <div class="col">
                                    <div class="form-group">
                                      <base-input formClasses="input-group-alternative" type="number" placeholder="0"
                                        step="1" min="0" v-model="v$.plot_model.params.soil.clay_percentage.$model"
                                        :error="errorsArrayToSingleString(v$.plot_model.params.soil.clay_percentage.$errors)">
                                      </base-input>
                                    </div>
                                  </div>
                                </div>
                                <!-- End of Soil clay_percentage -->

                                <!-- Soil lime_percentage -->
                                <div class="row">
                                  <div class="col">
                                    <span>{{ $t($route.name + '.paramsSoilLimePercentage') }}</span>
                                    <Popper arrow class="light" :content="$t($route.name + '.paramsSoilLimePercentageInfoPopover')">
                                          <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
                                  </div>
                                  <div class="col">
                                    <div class="form-group">
                                      <base-input formClasses="input-group-alternative" type="number" placeholder="0"
                                        step="1" min="0" v-model="v$.plot_model.params.soil.lime_percentage.$model"
                                        :error="errorsArrayToSingleString(v$.plot_model.params.soil.lime_percentage.$errors)">
                                      </base-input>
                                    </div>
                                  </div>
                                </div>
                                <!-- End of Soil lime_percentage -->

                                <!-- Soil sand_percentage -->
                                <div class="row">
                                  <div class="col">
                                    <span>{{ $t($route.name + '.paramsSoilSandPercentage') }}</span>
                                    <Popper arrow class="light" :content="$t($route.name + '.paramsSoilSandPercentageInfoPopover')">
                                          <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
                                  </div>
                                  <div class="col">
                                    <div class="form-group">
                                      <base-input formClasses="input-group-alternative" type="number" placeholder="0"
                                        step="1" min="0" v-model="v$.plot_model.params.soil.sand_percentage.$model"
                                        :error="errorsArrayToSingleString(v$.plot_model.params.soil.sand_percentage.$errors)">
                                      </base-input>
                                    </div>
                                  </div>
                                </div>
                                <!-- End of Soil sand_percentage -->

                                <!-- Soil soil_texture -->
                                <div class="row">
                                  <div class="col">
                                    <span>{{ $t($route.name + '.paramsSoilSoilTexture') }}</span>
                                    <Popper arrow class="light" :content="$t($route.name + '.paramsSoilSoilTextureInfoPopover')">
                                          <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
                                  </div>
                                  <div class="col">
                                    <div class="form-group">
                                      <base-input formClasses="input-group-alternative" type="text" disabled
                                        :placeholder="$t($route.name + '.paramsSoilSoilTexturePlaceholder')"
                                        :value="getSoilTexture()">
                                      </base-input>
                                    </div>
                                  </div>
                                </div>
                                <!-- End of Soil soil_texture -->

                                <!-- Soil texture_type -->
                                <div class="row">
                                  <div class="col">
                                    <span>{{ $t($route.name + '.paramsSoilTextureType') }}</span>
                                    <Popper arrow class="light" :content="$t($route.name + '.paramsSoilTextureTypeInfoPopover')">
                                          <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
                                  </div>
                                  <div class="col">
                                    <div class="form-group">
                                      <base-input disabled formClasses="input-group-alternative" type="text"
                                        :placeholder="$t($route.name + '.paramsSoilTextureTypePlaceholder')"
                                        :value="$t($route.name + '.' + plot_model.params.soil.texture_type)">
                                      </base-input>
                                    </div>
                                  </div>
                                </div>
                                <!-- End of Soil texture_type -->

                              </div>
                              <!-- End of Card-Body -->
                            </div>
                          </div>
                          <!-- End of Soil card -->
                        </div>
                        <!-- End of Row -->
                      </div>

                      <!-- Temperature card -->
                      <div class="row">
                        <div class="col">
                          <div class="card shadow">
                            <div class="card-header border-0">
                              <div class="row align-items-center" v-on:click="onCollapseButtonToggle('temperature')">
                                <div class="col">
                                  <h4 class="mb-0">{{ $t(this.$route.name + '.paramsTemperatureTitle') }}</h4>
                                </div>
                                <div class="col-md-auto">
                                  <div v-if="plot_front_data.colapsed_params.temperature">
                                    <i class="ni ni-fat-add"></i>
                                  </div>
                                  <div v-else>
                                    <i class="ni ni-fat-delete"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- Card Body -->
                            <div v-if="!plot_front_data.colapsed_params.temperature">
                              <div class="card-body">
                                <!-- Temperature max -->
                                <div class="row">
                                  <div class="col">
                                    <span>{{ $t($route.name + '.paramsTemperatureMax') }}</span>
                                    <Popper arrow class="light" :content="$t($route.name + '.paramsTemperatureMaxInfoPopover')">
                                          <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
                                  </div>
                                  <div class="col">
                                    <div class="form-group">
                                      <base-input formClasses="input-group-alternative" type="number" placeholder="0.000"
                                        step="0.001" min="0.000" v-model="v$.plot_model.params.temperature.max.$model"
                                        :error="errorsArrayToSingleString(v$.plot_model.params.temperature.max.$errors)">
                                      </base-input>
                                    </div>
                                  </div>
                                </div>
                                <!-- End of Temperature max -->
                                <!-- Temperature min -->
                                <div class="row">
                                  <div class="col">
                                    <span>{{ $t($route.name + '.paramsTemperatureMin') }}</span>
                                    <Popper arrow class="light" :content="$t($route.name + '.paramsTemperatureMinInfoPopover')">
                                          <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
                                  </div>
                                  <div class="col">
                                    <div class="form-group">
                                      <base-input formClasses="input-group-alternative" type="number" placeholder="0.000"
                                        step="0.001" v-model="v$.plot_model.params.temperature.min.$model"
                                        :error="errorsArrayToSingleString(v$.plot_model.params.temperature.min.$errors)">
                                      </base-input>
                                    </div>
                                  </div>
                                </div>
                                <!-- End of Temperature min -->


                                <!-- Temperature KT_coefficient -->
                                <!--<div class="row">
                                    <div class="col">
                                      <span>{{$t($route.name+'.paramsTemperatureKTCoefficient')}}</span>
                                      <Popper arrow class="light" :content="$t($route.name+'.paramsTemperatureKTCoefficientInfoPopover')"
                                        >
                                            <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
                                    </div>
                                    <div class="col">
                                      <div class="form-group">
                                        <base-input
                                            formClasses="input-group-alternative"
                                            type="number"
                                            placeholder="0.000"
                                            step="0.001"
                                            v-model="v$.plot_model.params.temperature.KT_coefficient.$model"
                                            :error="errorsArrayToSingleString(v$.plot_model.params.temperature.KT_coefficient.$errors)"
                                        >
                                        </base-input>
                                      </div>  
                                    </div>
                                  </div>
                                  -->
                                <!-- End of Temperature KT_coefficient -->

                                <!-- Temperature extraterrestrial solar radiation -->
                                <!-- <div class="row">
                                    <div class="col">
                                      <span>{{$t($route.name+'.paramsTemperatureExtraterrestrialSolarRadiation')}}</span>
                                      <Popper arrow class="light" :content="$t($route.name+'.paramsTemperatureExtraterrestrialSolarRadiationInfoPopover')"
                                        >
                                            <a type="button"><i class="ni ni-bulb-61"></i></a></Popper>
                                    </div>
                                    
                                      
                                        
                                  </div>
                                  <div class="row">
                                    <div class="col">
                                      <div v-if="plot_model.params.temperature.extraterrestrial_solar_radiation.length">
                                        <div class="table-responsive">
                                          <table class="table tablesorter">
                                            <thead>
                                              <th v-for="(item, index) in plot_model.params.temperature.extraterrestrial_solar_radiation" :key="index">
                                                {{$t($route.name+'.month'+index)}}
                                              </th>
                                            </thead>
                                            <tbody>
                                              <tr>
                                                <td v-for="(item, index) in plot_model.params.temperature.extraterrestrial_solar_radiation" :key="index">
                                                  <div v-if="index == getCurrentMonth()">
                                                    <b>{{item}}</b>
                                                  </div>
                                                  <div v-else>
                                                    {{item}}
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                      <div v-else>
                                        <span>{{$t($route.name+'.plotParamsNoExtraterrestrialSolarRadiation')}}</span>
                                      </div>
                                    </div>
                                  </div>
                                  -->
                                <!-- End of Temperature extraterrestrial solar radiation -->
                              </div>
                              <!-- End of Card-Body -->
                            </div>
                          </div>
                          <!-- End of Temperature card -->
                        </div>
                        <!-- End of Row -->
                      </div>
                    </div>
                    <!-- End of Plot params details -->
                    <!-- Plot module list -->
                    <div v-else-if="plot_front_data.selected_nav == 'modules'">
                      <div v-if="plot_model.modules.length">
                        <div class="table-responsive">
                          <a type="button" v-on:click="onModuleActionsClick('new_module')">
                            <i class="ni ni-fat-add text-blue"></i>
                            <span class="text-blue">{{ $t($route.name + '.plotModuleAddNew') }}</span>
                          </a>
                          <br>
                          <base-table thead-classes="thead-light" :data="plot_model.modules">
                            <template v-slot:columns>
                              <th>{{ $t($route.name + '.plotModuleNameHeader') }}</th>
                              <th>{{ $t($route.name + '.plotModuleActionHeader') }}</th>
                              <th>{{ $t($route.name + '.plotModuleTypeHeader') }}</th>
                              <th>{{ $t($route.name + '.plotModuleEnabledHeader') }}</th>
                              <th>{{ $t($route.name + '.plotModuleInstallationDateHeader') }}</th>
                            </template>

                            <template v-slot:default="row">
                              <th scope="row">
                                {{ row.item.name }}
                              </th>
                              <td>
                                <a type="button" v-on:click="onModuleActionsClick(row.item.id)">
                                  <i class="ni ni-settings-gear-65 text-blue fa-2x"></i>
                                </a>
                              </td>
                              <td>
                                {{ row.item.hw_specs.type + row.item.hw_specs.version + "." + row.item.sw_specs.version }}
                              </td>
                              <td>
                                <base-switch disabled :value="row.item.enabled">
                                </base-switch>

                              </td>
                              <td>
                                {{ row.item.installation_date }}
                              </td>
                            </template>
                          </base-table>
                        </div>
                      </div>
                      <div v-else>
                        <span>{{ $t($route.name + '.plotModulesNoModuleInList') }}</span>
                        <br>
                        <a type="button" v-on:click="onModuleActionsClick('new_module')">
                          <i class="ni ni-fat-add text-blue"></i>
                          <span class="text-blue">{{ $t($route.name + '.plotModuleAddNew') }}</span>
                        </a>
                      </div>
                    </div>
                    <br>
                    <!-- Plot form submit buttons -->
                    <div class="row">
                      <button class="btn btn-icon btn-primary" type="submit">
                        <div v-if="plot_front_data.plot_selected == 'new_plot_selected'">
                          <span class="btn-inner--icon"><i class="ni ni-bag-17"></i></span>
                          <span class="btn-inner--text">{{ $t($route.name + '.plotNewPlotButton') }}</span>
                        </div>
                        <div v-else>
                          <span class="btn-inner--icon"><i class="ni ni-bag-17"></i></span>
                          <span class="btn-inner--text">{{ $t($route.name + '.plotUpdate') }}</span>
                        </div>
                      </button>
                      <button type="button" class="btn btn-outline-default" v-on:click="resetPlotProfile()">
                        {{ $t($route.name + '.plotRestore') }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PlotService from '@/services/plot.service.js';
import TerrainService from '@/services/terrain.service.js';
//import LandlordService from '@/services/landlord.service.js';

import PlotModel from '@/views/Plots/plot.model.js'
import plot_params from '@/models/plot_params.js'

import useVuelidate from '@vuelidate/core'
import { required, minLength, helpers, minValue, maxValue } from '@vuelidate/validators'

export default {
  name: "plot-manager",
  setup() {
    return { v$: useVuelidate() }
  },
  validations() {
    return {
      plot_model: {
        name: {
          required_custom: helpers.withMessage(this.$t(this.$route.name + '.errorFieldRequired'), required),
          min: helpers.withMessage(this.$t(this.$route.name + '.errorInvalidLength', { length: '6' }), minLength(6)),
          valid_name: helpers.withMessage(this.$t(this.$route.name + '.errorNameAlreadyExists'), this.checkIfPlotNameAlreadyExists),
        },
        params: {
          plot_area: {
            required_custom: helpers.withMessage(this.$t(this.$route.name + '.errorFieldRequired'), required),
            minValue: helpers.withMessage(this.$t(this.$route.name + '.errorNegativeNumber'), minValue(0)),
          },
          total_crop_area: {
            required_custom: helpers.withMessage(this.$t(this.$route.name + '.errorFieldRequired'), required),
            minValue: helpers.withMessage(this.$t(this.$route.name + '.errorNegativeNumber'), minValue(0)),
          },
          temperature: {
            min: {
              required_custom: helpers.withMessage(this.$t(this.$route.name + '.errorFieldRequired'), required),
              minValue: helpers.withMessage(this.$t(this.$route.name + '.minTemperatureError', { temperature: "-20" }), minValue(-20)),
            },
            max: {
              required_custom: helpers.withMessage(this.$t(this.$route.name + '.errorFieldRequired'), required),
              maxValue: helpers.withMessage(this.$t(this.$route.name + '.maxTemperatureError', { temperature: "60" }), maxValue(60)),
            },
            KT_coefficient: {
              required_custom: helpers.withMessage(this.$t(this.$route.name + '.errorFieldRequired'), required),
            },

          },
          crop: {
            crop_type: {
              required_custom: helpers.withMessage(this.$t(this.$route.name + '.errorFieldRequired'), required),
            },
            plantation_age: {
              required_custom: helpers.withMessage(this.$t(this.$route.name + '.errorFieldRequired'), required),
              minValue: helpers.withMessage(this.$t(this.$route.name + '.errorNegativeNumber'), minValue(0)),
            },
            variety: {
              required_custom: helpers.withMessage(this.$t(this.$route.name + '.errorFieldRequired'), required),
            },
            variety_type: {
              required_custom: helpers.withMessage(this.$t(this.$route.name + '.errorFieldRequired'), required),
            },
            tree_distance: {
              required_custom: helpers.withMessage(this.$t(this.$route.name + '.errorFieldRequired'), required),
              minValue: helpers.withMessage(this.$t(this.$route.name + '.errorNegativeNumber'), minValue(0)),
            },
            row_distance: {
              required_custom: helpers.withMessage(this.$t(this.$route.name + '.errorFieldRequired'), required),
              minValue: helpers.withMessage(this.$t(this.$route.name + '.errorNegativeNumber'), minValue(0)),
            },
            crown_diameter: {
              required_custom: helpers.withMessage(this.$t(this.$route.name + '.errorFieldRequired'), required),
              minValue: helpers.withMessage(this.$t(this.$route.name + '.errorNegativeNumber'), minValue(0)),
            },
            cup_height: {
              required_custom: helpers.withMessage(this.$t(this.$route.name + '.errorFieldRequired'), required),
              minValue: helpers.withMessage(this.$t(this.$route.name + '.errorNegativeNumber'), minValue(0)),
            },
            visible_root_depth: {
              required_custom: helpers.withMessage(this.$t(this.$route.name + '.errorFieldRequired'), required),
              minValue: helpers.withMessage(this.$t(this.$route.name + '.errorNegativeNumber'), minValue(0)),
            },
            crop_coefficient: {
              required_custom: helpers.withMessage(this.$t(this.$route.name + '.errorFieldRequired'), required),
            },
            crop_development_coefficient: {
              required_custom: helpers.withMessage(this.$t(this.$route.name + '.errorFieldRequired'), required),
            },
          },
          irrigation: {
            irrigation_system: {
              required_custom: helpers.withMessage(this.$t(this.$route.name + '.errorFieldRequired'), required),
            },
            dropper_type: {
              required_custom: helpers.withMessage(this.$t(this.$route.name + '.errorFieldRequired'), required),
            },
            dropper_flow: {
              required_custom: helpers.withMessage(this.$t(this.$route.name + '.errorFieldRequired'), required),
              minValue: helpers.withMessage(this.$t(this.$route.name + '.errorNegativeNumber'), minValue(0)),
            },
            droppers_per_tree: {
              required_custom: helpers.withMessage(this.$t(this.$route.name + '.errorFieldRequired'), required),
              minValue: helpers.withMessage(this.$t(this.$route.name + '.errorNegativeNumber'), minValue(0)),
            },
            droppers_distance: {
              required_custom: helpers.withMessage(this.$t(this.$route.name + '.errorFieldRequired'), required),
              minValue: helpers.withMessage(this.$t(this.$route.name + '.errorNegativeNumber'), minValue(0)),
            },
            application_efficiency: {
              required_custom: helpers.withMessage(this.$t(this.$route.name + '.errorFieldRequired'), required),
              minValue: helpers.withMessage(this.$t(this.$route.name + '.errorNegativeNumber'), minValue(0)),
            },
          },
          soil: {
            uniformity_coefficient: {
              required_custom: helpers.withMessage(this.$t(this.$route.name + '.errorFieldRequired'), required),
            },
            organic_material: {
              required_custom: helpers.withMessage(this.$t(this.$route.name + '.errorFieldRequired'), required),
              minValue: helpers.withMessage(this.$t(this.$route.name + '.errorNegativeNumber'), minValue(0)),
            },
            clay_percentage: {
              required_custom: helpers.withMessage(this.$t(this.$route.name + '.errorFieldRequired'), required),
              minValue: helpers.withMessage(this.$t(this.$route.name + '.errorNegativeNumber'), minValue(0)),
            },
            lime_percentage: {
              required_custom: helpers.withMessage(this.$t(this.$route.name + '.errorFieldRequired'), required),
              minValue: helpers.withMessage(this.$t(this.$route.name + '.errorNegativeNumber'), minValue(0)),
            },
            sand_percentage: {
              required_custom: helpers.withMessage(this.$t(this.$route.name + '.errorFieldRequired'), required),
              minValue: helpers.withMessage(this.$t(this.$route.name + '.errorNegativeNumber'), minValue(0)),
            },
            texture_type: {
              required_custom: helpers.withMessage(this.$t(this.$route.name + '.errorFieldRequired'), required),
            },
          },
        },
      },
    }
  },
  created() {
    var landlord = JSON.parse(localStorage.getItem("landlord"));
    this.landlord = landlord;

    landlord.terrains.forEach(terrain => {
      TerrainService.getTerrainById(terrain.id).then(terrain => {
        terrain.plots.forEach(plot => this.landlord_plots.push(plot));
      });
    });

  },
  mounted() {
    if (this.plotId == "") {
      this.plot_front_data.plot_selected = "new_plot_selected";
    } else {
      this.plot_front_data.plot_selected = this.plotId;
    }
    // console.log(this.plot_front_data.plot_selected)
    this.onPlotSelect(this.plot_front_data.plot_selected);
  },
  props: {
    plotId: String
  },
  data() {
    return {
      landlord_plots: [],
      plot_front_data: {
        plot_selected: '',
        selected_nav: 'profile',
        colapsed_params: {
          temperature: true,
          soil: true,
          crop: true,
          irrigation: true,
        }
      },
      plot_model: PlotModel.plot_read_model,
      landlord: null,
      plot_original: PlotModel.plot_read_model,
      errors: [],
    }
  },
  methods: {
    handleUpdatePlot() {

      // Check all validators
      this.v$.$touch();
      if (this.v$.plot_model.$invalid) {
        if (this.v$.plot_model.params.$invalid) {
          this.plot_front_data.selected_nav = 'profile';
          if (this.v$.plot_model.params.temperature.$invalid) {
            this.plot_front_data.colapsed_params.temperature = false;
            this.plot_front_data.selected_nav = 'params';
            this.errors.push(this.$t(this.$route.name + '.errorModalTemperatureParams'))
          } else {
            this.plot_front_data.colapsed_params.temperature = true;
          }
          if (this.v$.plot_model.params.crop.$invalid) {
            this.plot_front_data.colapsed_params.crop = false;
            this.plot_front_data.selected_nav = 'params';
            this.errors.push(this.$t(this.$route.name + '.errorModalCropParams'))
          } else {
            this.plot_front_data.colapsed_params.crop = true;
          }
          if (this.v$.plot_model.params.irrigation.$invalid) {
            this.plot_front_data.colapsed_params.irrigation = false;
            this.plot_front_data.selected_nav = 'params';
            this.errors.push(this.$t(this.$route.name + '.errorModalIrrigationParams'))
          } else {
            this.plot_front_data.colapsed_params.irrigation = true;
          }
          if (this.v$.plot_model.params.soil.$invalid) {
            this.plot_front_data.colapsed_params.soil = false;
            this.plot_front_data.selected_nav = 'params';
            this.errors.push(this.$t(this.$route.name + '.errorModalSoilParams'))
          } else {
            this.plot_front_data.colapsed_params.soil = true;
          }
          return;
        }

        if (this.plot_front_data.plot_selected == "new_plot_selected") {

          if (this.v$.plot_model.$errors.length == 1) {
            if (this.v$.plot_model.name.$invalid) {
              // skip validation

            } else {
              this.plot_front_data.selected_nav = 'profile';
              this.errors.push(this.$t(this.$route.name + '.errorModalProfile'))
              return;
            }
          } else if (this.v$.plot_model.$errors.length > 0) {
            this.plot_front_data.selected_nav = 'profile';
            this.errors.push(this.$t(this.$route.name + '.errorModalProfile'))
            return;
          }
        }
      }

      // Get terrain to extract the latitude
      const terrain = this.landlord.terrains.find(terrain => terrain.id == this.plot_model.terrain_id);
      const lat = parseInt(terrain.coordinates.split(',')[0]).toString();

      if (lat in plot_params.esr.lat) {
        this.plot_model.params.temperature.extraterrestrial_solar_radiation = '[' + plot_params.esr.lat[lat].toString() + ']';
      } else {
        this.plot_model.params.temperature.extraterrestrial_solar_radiation = '[]'
      }

      // Getting here means all fields of the form are correct
      if (this.plot_front_data.plot_selected == "new_plot_selected") {

        // create new plot id
        const plot_id = this.plot_model.name.replaceAll(' ', '_');
        this.plot_model.id = plot_id;
        this.plot_model.crop_id = this.plot_model.params.crop.crop_type;

        // Create plot service
        PlotService.createPlot(this.plot_model).then(
          () => {
            // Reload the page to refresh data
            this.$router.push({ name: 'plots' })
          },
          error => {
            console.log(error)
          }
        );
      } else {
        // console.log(this.plot_model);
        // update model data
        PlotService.updatePlotById(this.plot_model.id, this.plot_model).then(
          () => {
            PlotService.updatePlotParamsById(this.plot_model.id, this.plot_model.params).then(
              () => {
                // Reload the page to refresh data
                this.$router.push({ name: 'plots' })
              },
              error => {
                console.log(error)
              }
            );
          },
          error => {
            console.log(error)
          }
        );

      }
    },
    onPlotSelect(plot_id) {
      if (plot_id == "new_plot_selected") {
        this.plot_model = JSON.parse(JSON.stringify(PlotModel.plot_read_model));
        this.plot_original = JSON.parse(JSON.stringify(PlotModel.plot_read_model));
      } else {
        PlotService.getPlotById(plot_id).then(
          plot => {
            // Transform string list to list
            const esr = JSON.parse(plot.params.temperature.extraterrestrial_solar_radiation);
            let corrected_plot = plot;
            corrected_plot.params.temperature.extraterrestrial_solar_radiation = esr;
            this.plot_model = corrected_plot;
            this.plot_original = JSON.parse(JSON.stringify(corrected_plot));
          }
        );
      }

    },
    onPlotNavButtonsClick(nav_item) {
      this.plot_front_data.selected_nav = nav_item;
    },
    resetPlotProfile() {
      this.plot_model = JSON.parse(JSON.stringify(this.plot_original));
    },
    errorsArrayToSingleString(array) {
      var str = "";
      if (array.length == 0) return
      array.forEach(item => str += item.$message + '\n')
      return str;
    },
    checkIfPlotNameAlreadyExists(name) {
      // return true if doesn't exists and false if it does
      return this.landlord_plots.filter(plot => plot.name === name).length == 0;
    },
    onTerrainChange(event) {
      this.plot_model.terrain_id = event.target.value;
    },

    getCurrentMonth() {
      const d = new Date();
      return d.getMonth();
    },

    getDropperTypes() {
      return plot_params.dropper_types;
    },

    getIrrigationSystems() {
      return plot_params.irrigation_systems;
    },

    getCropTypeVarieties() {
      return plot_params.crop_type_varieties;
    },

    getCropType() {
      return plot_params.crop_type_list;
    },

    onIrrigationSystemSelected() {
      const irr_sys = this.plot_model.params.irrigation.irrigation_system;

      const ea = plot_params.application_efficiency[irr_sys];
      this.plot_model.params.irrigation.application_efficiency = ea;
    },

    getSoilTexture() {
      const clay = this.plot_model.params.soil.clay_percentage;
      const lime = this.plot_model.params.soil.lime_percentage;
      const sand = this.plot_model.params.soil.sand_percentage;

      const texture = plot_params.soil_textures.find(texture => (
        texture.clay.low_threshold <= clay && texture.clay.high_threshold >= clay &&
        texture.lime.low_threshold <= lime && texture.lime.high_threshold >= lime &&
        texture.sand.low_threshold <= sand && texture.sand.high_threshold >= sand
      ));
      if (texture) {
        this.plot_model.params.soil.soil_texture = texture.name;
        this.plot_model.params.soil.texture_type = texture.type;
        return this.$t(this.$route.name + '.' + texture.name);
      }
      return null;
    },

    onCollapseButtonToggle(event) {
      switch (event) {
        case 'crop':
          this.plot_front_data.colapsed_params.crop = !this.plot_front_data.colapsed_params.crop;
          break;
        case 'temperature':
          this.plot_front_data.colapsed_params.temperature = !this.plot_front_data.colapsed_params.temperature;
          break;
        case 'irrigation':
          this.plot_front_data.colapsed_params.irrigation = !this.plot_front_data.colapsed_params.irrigation;
          break;
        case 'soil':
          this.plot_front_data.colapsed_params.soil = !this.plot_front_data.colapsed_params.soil;
          break;
        default:
          break;
      }
    },

    get_crop_development_coefficient() {
      const plantation_mark = (this.plot_model.params.crop.row_distance * this.plot_model.params.crop.tree_distance) / 10000;
      const crop_coverage = 3.14159 * 100 * (((this.plot_model.params.crop.crown_diameter / 100) ** 2) / 4) / plantation_mark;
      var kr;
      if (crop_coverage > 65) {
        kr = 100;
      } else {
        kr = (-0.0194 * (crop_coverage ** 2)) + (2.8119 * crop_coverage) - 1.008;
      }
      return kr / 100;
    },

    onModuleActionsClick(moduleId) {
      localStorage.setItem('moduleId', moduleId)
      this.$router.push({ name: 'modules' })
    }
  },
};
</script>
<style scoped>
.divider {
  font-size: 1px;
  background: rgba(0, 0, 0, 0.5);
}

.light {
  --popper-theme-background-color: #ffffff;
  --popper-theme-background-color-hover: #ffffff;
  --popper-theme-text-color: #333333;
  --popper-theme-border-width: 1px;
  --popper-theme-border-style: solid;
  --popper-theme-border-color: #eeeeee;
  --popper-theme-border-radius: 6px;
  --popper-theme-padding: 32px;
  --popper-theme-box-shadow: 0 6px 30px -6px rgba(0, 0, 0, 0.25);
}
</style>
